module.exports = __webpack_public_path__ + "static/media/imac-placeholder.19258c31.webp";